import { create } from "zustand";

interface IntercomState {
  isIntercomOpen: boolean;
}

interface IntercomActions {
  setIsIntercomOpen: (open: boolean) => void;
}

const initState: IntercomState = {
  isIntercomOpen: false,
};

type IntercomStore = IntercomState & IntercomActions;

export const useIntercomStore = create<IntercomStore>((set) => ({
  ...initState,
  setIsIntercomOpen: (isIntercomOpen) =>
    set(() => ({
      isIntercomOpen,
    })),
}));
